import { readable } from "svelte/store";
import { getDistance } from 'geolib';
import { State } from "../Model/State";
const overridePosition = new State(undefined);
let hasPosition = false;
export function override(position) {
    hasPosition = true;
    overridePosition.set(position);
}
export function hasPlayerPosition() {
    return hasPosition;
}
export const playerPosition = readable(undefined, set => {
    let unsubNavigator;
    const unsubOverrided = overridePosition.subscribe(position => {
        if (position) {
            unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
            unsubNavigator = undefined;
            set(position);
            return;
        }
        if (unsubNavigator) {
            return;
        }
        unsubNavigator = navigatorPosition.subscribe(set);
    });
    return () => {
        unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
        unsubOverrided();
    };
});
export function calcDistance(c1, c2) {
    return getDistance(c1, c2);
}
export function calcBearing({ lat: startLat, lon: startLng }, { lat: destLat, lon: destLng }) {
    startLat = toRadians(startLat);
    startLng = toRadians(startLng);
    destLat = toRadians(destLat);
    destLng = toRadians(destLng);
    const y = Math.sin(destLng - startLng) * Math.cos(destLat);
    const x = Math.cos(startLat) * Math.sin(destLat) - Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
    const brng = toDegrees(Math.atan2(y, x));
    return (brng + 360) % 360;
}
const navigatorPosition = readable(undefined, set => {
    const watchId = window.navigator.geolocation.watchPosition(({ coords }) => {
        hasPosition = true;
        set({ lon: coords.longitude, lat: coords.latitude });
    }, error => console.error(error), {
        enableHighAccuracy: true
    });
    return () => window.navigator.geolocation.clearWatch(watchId);
});
// Converts from degrees to radians.
function toRadians(degrees) {
    return degrees * Math.PI / 180;
}
;
// Converts from radians to degrees.
function toDegrees(radians) {
    return radians * 180 / Math.PI;
}
